import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Form } from "react-bootstrap";
import "./Checkbox.scss";

const propTypes = {
  /**
   * If true, checkbox will be styled as indeterminate
   */
  indeterminate: PropTypes.bool,
  /**
   * Class to modify default styles
   */
  className: PropTypes.string,
  /**
   * Label of the checkbox
   */
  label: PropTypes.node,
};

const defaultProps = {
  indeterminate: false,
  className: "",
  label: "",
};

/**
 * Checkbox component based on https://react-bootstrap-v4.netlify.app/components/forms/#forms-form-check
 */
function Checkbox(props) {
  const { className, indeterminate, label, ...rest } = props;

  return (
    <Form.Check
      custom
      type="checkbox"
      label={label}
      className={clsx("Uic-Checkbox-base", className)}
      ref={(input) => {
        if (input) input.indeterminate = indeterminate; // eslint-disable-line no-param-reassign
      }}
      {...rest}
    />
  );
}

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default Checkbox;
